import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size", "color"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * DON'T EDIT THIS FILE DIRECTLY
 *
 * This file was auto-generated from an SVG icon.
 * Edit '/components/icons/template.js' to make changes
 * to the generated React component.
 *
 * See '/components/icons/README.stories.mdx' for details.
 */

import React, { forwardRef } from 'react';
import { useTheme } from 'styled-components';
import { getColorBlock } from 'utils/ui';
import BaseSvg from '../BaseSvg';
import { jsx as _jsx } from "react/jsx-runtime";
var SkipIcon = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 18 : _props$size,
    color = props.color,
    otherProps = _objectWithoutProperties(props, _excluded);
  var theme = useTheme();
  var fillColor = color ? getColorBlock(color, theme) : 'currentColor';

  // Unless the icon has an explicit ARIA label, we'll hide it visually
  var ariaHidden = !(otherProps['aria-label'] || otherProps['aria-labelledby']) || undefined;
  return /*#__PURE__*/_jsx(BaseSvg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    viewBox: "0 0 18 18",
    width: size,
    height: size,
    fill: fillColor,
    fillRule: "evenodd",
    clipRule: "evenodd",
    focusable: "false",
    "aria-hidden": ariaHidden,
    children: /*#__PURE__*/_jsx("path", {
      d: "M9 6C6.23858 6 4 8.23858 4 11C4 11.5523 3.55228 12 3 12C2.44772 12 2 11.5523 2 11C2 7.13401 5.13401 4 9 4C12.0911 4 14.7143 6.0036 15.6416 8.78296L17.1032 8.53985C17.1981 8.52406 17.2745 8.61694 17.2407 8.70704L15.5683 13.1669C15.5345 13.257 15.4158 13.2767 15.3547 13.2024L12.3286 9.52412C12.2674 9.44981 12.3097 9.33719 12.4046 9.3214L13.6333 9.11701C12.8896 7.28885 11.0953 6 9 6ZM9 12.9999C7.895 12.9999 7 12.1049 7 10.9999C7 9.89494 7.895 8.99994 9 8.99994C10.105 8.99994 11 9.89494 11 10.9999C11 12.1049 10.105 12.9999 9 12.9999Z"
    })
  }));
});
SkipIcon.displayName = 'SkipIcon';
export default SkipIcon;